export default "__VITE_ASSET__DEf4U1R___"